<template>
	<div class="vehicle">
		<target></target>
		<!-- 地图 行 -->
		<Center :type="type" />
		<!-- ？ -->
		<part1></part1>
		<!-- ？ -->
		<part2></part2>
		<!-- ？ -->
		<part3></part3>
		<!-- ？ -->
		<part4></part4>
	</div>
</template>
<script>
import target from './components/pcsite/target'
import Center from "./components/pcsite/center"
import part1 from "./components/pcsite/part1"
import part2 from "./components/pcsite/part2"
import part3 from "./components/pcsite/part3"
import part4 from "./components/pcsite/part4"
export default {
	data() {
		return {}
	},
	props: {
		type: {
			type: String,
			default: ''
		}
	},
	components: {
		target,
		Center,
		part1,
		part2,
		part3,
		part4
		// partTwo,
	},
	mounted() {
		if (this.$route.query && this.$route.query.province) {
      console.log('省')
			this.adcode = this.$route.query.province;
			this.$EventBus.$emit('update', {
				province: this.adcode
			});
		} else if (this.$route.query && this.$route.query.city) {
      console.log('市')
			this.adcode = this.$route.query.city;
			this.$EventBus.$emit('update', {
				city: this.adcode
			});
		} else if (this.$route.query && this.$route.query.district) {
      console.log('区')
			this.adcode = this.$route.query.district;
			this.$EventBus.$emit('update', {
				district: this.adcode
			});
		} else {
      console.log('省市区')
			this.type = 'nationwideSite'
			this.$EventBus.$emit('update', '');
		}

	},
}
</script>

<style lang="scss" scoped>
.vehicle {
	position: relative;
	padding-bottom: 100px;
}
</style>